import {Http, Headers, RequestOptions} from '@angular/http';

import 'rxjs/add/operator/map';
import * as myGlobals from '../global';


export class FillerService {  

    apiBasePath: any;

    static get parameters() {
        return [[Http]];
    }
 
	constructor(private http: Http) {
		this.apiBasePath = myGlobals.apiBasePath;
	}

    ApiInvoke = function (url, method, payload = "") {

        var param = {
            url: url,
            method: method ? "POST" : method,
            data: {},
            headers: {
                api_key: myGlobals.apikey 
            }
        }; 

        var response;
        var headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('api_key', myGlobals.apikey);


        var data2 = payload == "" ? JSON.stringify({ "UICulture": "it"}) : payload ;   
        var options = new  RequestOptions({ headers: headers });

        response = this.http.post(url,data2,options).map(res => res.json());
        // console.log(url);
        // console.log(data2);
        // console.log(options);

        /*var def = $q.defer();
        $http(param).then(
            function (e) {
                def.resolve(e);
            },
            function (e) {
                switch (e.status) {
                    case 0:
                        console.log("HttpStatus is zero: deleting IDS. Check if cross origin is allowed. Trashing IDS data.", e);
                        break;
                    case 302:
                        console.log("302 status");
                        break;
                    case 400:
                        console.log("HTTP Status 400: ", e);
                        break;
                    case 401:
                        break;
                    case 404:
                        console.log("HTTP Status 404:", e);
                        break;
                    default:
                        console.log("Unknow status:", e);
                }
                def.reject(e);
            });
        return def.promise;*/
        return response;
    }

    
    Get_GroupList = function () {
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/group-list", "POST");
    }

    Get_CategoryInAds = function () {
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/category-in-advertisement-list", "POST");
    }

    Get_TypeInAds = function () { 
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/type-in-advertisement-list", "POST");
    }

    Get_CityInAds = function () {
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/city-in-advertisement-list", "POST");
    }

    Get_Configuration = function () {
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/configuration", "POST")
    }

    Get_AdsList = function (payload) {
        
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/advertisement-list", "POST", payload)
    }

    Get_AdsListStats = function (payload) {
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/advertisement-list-stats", "POST", payload)
    }

    Get_Advertisement = function (payload) {
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/advertisement", "POST", payload)
    }

    Get_News_List = function (payload) {
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/news/news-list", "POST",payload);
    }

    Get_News = function (payload) {
         return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/news/news", "POST", payload);
    }

    Get_About = function () {

        var payload = '{ key: "about_us", UICulture: "it" }';
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/page/page-key", "POST", payload);
    }

    Get_Services = function () {

        var payload = '{ key: "services", UICulture: "it" }';
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/page/page-key", "POST", payload);
    }

    Get_Privacy = function () {

        var payload = '{ key: "privacy", UICulture: "it" }';
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/page/page-key", "POST", payload);
    }    

    Send_EmailContacts = function(payload) {
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/send-user-contact-request", "POST", payload);
    }

    Send_EmailAdvertisement = function(payload) {
        return this.ApiInvoke(this.apiBasePath + "/Public/ServiceRealEstate/send-user-advertisement-request", "POST", payload);
    }

}


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/common/Service_tnFiller.ts